import styled from "styled-components"
import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, Email as EmailIcon, GetApp as FileDownloadIcon} from "@mui/icons-material"

import {api, CustomerNOALetterSentActivityPayload} from "@indebted/api"

function NOALetterSentActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerNOALetterSentActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string},
) {
	const handleDownloadPDF = () => {
		const a = document.createElement("a")
		a.href = api.url(Payload.ContentDownloadURI)
		a.target = "_blank"
		a.rel = "noreferrer"
		a.download = `noa-letter-${panelId}.pdf`
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)
	}

	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
				<EmailIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</StyledAccordionSummary>
			<AccordionDetails>
				{expanded && (
					<StyledDetailsContainer>
						<StyledHeaderRow>
							<Typography variant="body1" gutterBottom>
								<b>Notice of Assignment Letter</b>
							</Typography>
							{Payload.ContentDownloadURI && (
								<StyledDownloadButton onClick={handleDownloadPDF}>
									<FileDownloadIcon color="primary" />
									<Typography variant="body2" component="span" style={{marginLeft: "4px"}}>
										Download PDF
									</Typography>
								</StyledDownloadButton>
							)}
						</StyledHeaderRow>
						<StyledIFrame allowFullScreen src={api.url(Payload.ContentURI)} />
					</StyledDetailsContainer>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

const StyledDetailsContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 16px;
`

const StyledHeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`

const StyledIFrame = styled.iframe`
	width: 100%;
	flex-grow: 1;
	height: 600px;
	border: none;
`

const StyledAccordionSummary = styled(AccordionSummary)`
	.MuiAccordionSummary-content {
		position: relative;
	}
`

const StyledDownloadButton = styled.button`
	display: flex;
	align-items: center;
	border: none;
	background: none;
	cursor: pointer;
	padding: 8px 12px;
	border-radius: 4px;
	color: #1976d2;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: rgba(25, 118, 210, 0.08);
	}

	&:focus {
		outline: 2px solid #1976d2;
		outline-offset: 2px;
	}
`

export {NOALetterSentActivity}
